export const RULE_VENDA_CANCELAMENTO = "ROLE_VENDA_CANCELAMENTO_INSERIR";
export const RULE_VENDA_DEVOLUCAO = "ROLE_VENDA_DEVOLUCAO_INSERIR";
export const RULE_SANGRIA = "ROLE_SANGRIA_CAIXA_INSERIR";
export const RULE_ADMIN = "ROLE_ADMIN";
